import * as React from "react";
import DynamicIcon from "./dynamicicon";
import JisButton from "./controls/jisButton";

export default function JisDialogForm({
  children,
  title = "",
  onClose,
  minWidth = "50%",
}) {
  return (
    <div className="dialog-overlay">
      <div className="dialog-wrapper dialog-wrapper--open">
        <div
          style={{
            position: "relative",
            width: "fit-content",
            minWidth: minWidth,
            maxWidth: "90%",
            overflow: "hidden",
            borderRadius: "15px",
            margin: "auto",
          }}
        >
          <div className="dialog-backdrop" />
          <div className="dialog-header">
            <h2 className="dialog-header__title">{title}</h2>
            <button
              className="dialog-header__close-btn"
              onClick={onClose}
              aria-label="Close"
            >
              <DynamicIcon size={24} color="white" iname="circle-x" />
            </button>
          </div>
          <div
            className="dialog-container"
            style={{
              width: "100%",
              // header stays at the top, the body scrolls inside the screen height
              maxHeight: "calc(100vh - 120px)",
              overflowY: "auto",
            }}
          >
            <div className="dialog-content">
              <div className="dialog-body">{children}</div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
